module.exports = __webpack_public_path__ + "static/img/step-5.ed1e665.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/local/step-5.svg
// module id = dwx6
// module chunks = 1